import { FC, useEffect, useState } from "react";
import PopupModal from "../../../../UI/Popup";

interface ViewReferroDetailsProps {
  showReferroDetailsModal: boolean;
  onClickClose: () => void;
  pdfDocument: string;
}

const ViewReferroDetails: FC<ViewReferroDetailsProps> = ({
  showReferroDetailsModal,
  onClickClose,
  pdfDocument
}) => {
    const [pdfUrl, setPdfUrl] = useState<string>("");
    const [isLoadingPdf, setIsLoadingPdf] = useState<boolean>(false);
    const [pdfLoadError, setPdfLoadError] = useState<string>("");

    useEffect(() => {
        let objectUrl: string | null = null;
        const controller = new AbortController();

        if (!showReferroDetailsModal || !pdfDocument) {
            setPdfUrl("");
            setPdfLoadError("");
            return;
        }

        const loadPdf = async () => {
            try {
                setIsLoadingPdf(true);
                setPdfLoadError("");

                const response = await fetch(pdfDocument, {
                    signal: controller.signal
                });

                if (!response.ok) {
                    throw new Error(`Unable to load document (${response.status})`);
                }

                const blob = await response.blob();
                objectUrl = URL.createObjectURL(blob);
                setPdfUrl(objectUrl);
            } catch (error: any) {
                if (error?.name === "AbortError") {
                    return;
                }
                setPdfUrl("");
                setPdfLoadError("You can open the document in a new tab.");
            } finally {
                setIsLoadingPdf(false);
            }
        };

        loadPdf();

        return () => {
            controller.abort();
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [showReferroDetailsModal, pdfDocument]);

    const handleClose = () => {
        onClickClose();
    };

    return (
        <PopupModal
            visible={showReferroDetailsModal}
            showCloseBtn={true}
            onClickClose={handleClose}
            customWidth={1000}
        >
            {showReferroDetailsModal && (
                <div className="mt-3">
                    {isLoadingPdf && (
                        <div className="fs-13 text-grey-dark mb-10">Loading document preview...</div>
                    )}
                    
                        <div className="fs-13 text-alert mb-10">
                            {pdfLoadError}{" "}
                            <a href={pdfDocument} target="_blank" rel="noopener noreferrer">
                                Open document in new tab
                            </a>
                        </div>
                    
                    {pdfUrl && (
                        <iframe
                            src={pdfUrl}
                            title="Referoo PDF Viewer"
                            className="popup-pdf-iframe mt-3"
                        />
                    )}
                </div>
            )}
        </PopupModal>
    );
};

export default ViewReferroDetails;
